import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import AutoQuery from 'servicestack/auto-query/auto-query'
import $session from 'servicestack/session'

class VendorContactPromptController {
    constructor($rootScope, $uibModalInstance, options) {
        var $ctrl = this;
        basicController($ctrl);
		var model = $ctrl.model = options.model;
		var bus = $ctrl.bus = new ServiceBus($rootScope);
		$ctrl.$uibModalInstance = $uibModalInstance;
		if (!$ctrl.model.contact) {
			var date = new Date();
			$ctrl.model.contact = {
				vendorId: $ctrl.model.vendor.id,
				createdBy: $session.userAuthName,
				username: $session.userAuthName
			}
		}

		if ($ctrl.model.contact.vendorId) {
			var vendorQuery = new AutoQuery({
				url: 'QueryVendors.json?Id=' + $ctrl.model.contact.vendorId,
				orderBy: 'Label',
				autoLoad: true,
				onLoaded: args => { $ctrl.model.vendor = args.first; }
			});
		}

		$ctrl.title = options.title || 'Contact'
		$ctrl.save = $ctrl.submit = function () {
			if ($ctrl.model.contact.id) {
				bus.send('UpdateVendorContact.json', $ctrl.model.contact).then(function (response) {
					$rootScope.$emit('contactSaved', $ctrl.model);
					$uibModalInstance.close($ctrl.model);
				});
			} else {
				bus.send('CreateVendorContact.json', $ctrl.model.contact).then(function (response) {
					$rootScope.$emit('contactSaved', $ctrl.model);
					$uibModalInstance.close($ctrl.model);
				});
			}
		};
		$ctrl.delete = function () {
			$uibModalInstance.close($ctrl.model);
			return modals.confirm("Are you sure?", "Delete Contact").result.then(function () {
				$ctrl.bus.send('DeleteVendorContact.json', $ctrl.model.contact).then(function (response) {
					$rootScope.$emit('contactDeleted', $ctrl);
				});
			});
		}
    }
	dismiss(reason) {
		let $ctrl = this;
		$ctrl.$uibModalInstance.close(reason);
	}
}

export default VendorContactPromptController;